import { configureStore } from "@reduxjs/toolkit"
import AuthReducer from "./reducers/AuthReducer"
import userReducer from "./reducers/UserReducer";
import layoutReducer from "./reducers/LayoutReducer";
import stateReducer from "./reducers/StateReducer";
import cityReducer from "./reducers/CityReducer";
import talukaReducer from "./reducers/TalukaReducer";
import villageReducer from "./reducers/VillageReducer";
import zoneReducer from "./reducers/ZoneReducer";
import userTypeReducer from "./reducers/UserTypeReducer";
import masterReducer from "./reducers/MasterReducer";
import geofenceReducer from "./reducers/GeofenceReducer";
import hospitalReducer from "./reducers/HospitalReducer";
import doctorReducer from "./reducers/DoctorReducer";
import employeeReducer from "./reducers/EmployeeReducer";
import pathologyReducer from "./reducers/PathologyReducer";
import radiologyReducer from "./reducers/RadiologyReducer";
import pharmacyReducer from "./reducers/PharmacyReducer";
import agentBrokerReducer from "./reducers/AgentBrokerReducer";
import corporateReducer from "./reducers/CorporateReducer";
import basicSaveReducer from "./reducers/BasicSaveReducer";
import designationReducer from "./reducers/DesignationReducer";
import educationReducer from "./reducers/EducationReducer";
import educationTypeReducer from "./reducers/EducationTypeReducer";
import gradeOfEvidenceReducer from "./reducers/GradeOfEvidenceReducer";
import reasonForRejectionReducer from "./reducers/ReasonForRejectionReducer";
import sourceOfEvidenceReducer from "./reducers/SourceOfEvidenceReducer";
import fraudTypeReducer from "./reducers/FraudTypeReducer";
import policySubReasonReducer from "./reducers/PolicySubReasonReducer";
import incomeReducer from "./reducers/IncomeReducer";
import jobReducer from "./reducers/JobReducer";
import patientDataReducer from "./reducers/PatientDataReducer";
import policyDataReducer from "./reducers/PolicyDataReducer";
import localityReducer from "./reducers/LocalityReducer";
import occupationReducer from "./reducers/OccupationReducer";
import relationshipReducer from "./reducers/RelationshipReducer";
import checklistReducer from "./reducers/ChecklistReducer";
import subChecklistReducer from "./reducers/SubChecklistReducer";
import typeOfClaimReducer from "./reducers/TypeOfClaimReducer";
import insuranceReducer from "./reducers/InsuranceReducer";
import insuranceManagerReducer from "./reducers/InsuranceManagerReducer";
import roomTypeReducer from "./reducers/RoomTypeReducer";
import hospitalizationReducer from "./reducers/HospitalizationReducer";
import injuryTypeReducer from "./reducers/InjuryTypeReducer";
import generalSettingReducer from "./reducers/GeneralSettingReducer";
import userTypePermissionReducer from "./reducers/UserTypePermissionReducer";
import userPermissionReducer from "./reducers/UserPermissionReducer";
import caseDetailsReducer from "./reducers/CaseDetailsReducer";
import healthReducer from "./reducers/HealthReducer";
import tdsReducer from "./reducers/TDSReducer";
import caseDoctorReducer from "./reducers/CaseDoctorReducer";
import casePharmacyReducer from "./reducers/CasePharmacyReducer";
import caseHospitalReducer from "./reducers/CaseHospitalReducer";
import casePathologyReducer from "./reducers/CasePathologyReducer";
import occupationDataReducer from "./reducers/OccupationDataReducer";
import facilityReducer from "./reducers/FacilityAvailableReducer";
import keywordReducer from "./reducers/ReportKeywordReducer";
import serviceTypeReducer from "./reducers/ServiceTypeReducer";
import subClaimTypeReducer from "./reducers/SubClaimTypeReducer";
import claimTypeReducer from "./reducers/ClaimTypeReducer";
import pincodeReducer from "./reducers/PincodeReducer";
import groupDetailReducer from "./reducers/GroupDetailReducer";
import recruitmentReducer from "./reducers/RecruitmentReducer";
import newEmployeeReducer from "./reducers/NewEmployeeReducer";
import payrollReducer from "./reducers/PayrollReducer";
import accidentalCaseReducer from "./reducers/AccidentalCaseReducer";
import doctorReducerApproval from "./reducers/DoctorReducerApproval";
import corporateApprovalReducer from "./reducers/CorporateApprovalReducer";
import pharmacyReducerApproval from "./reducers/PharmacyReducerApproval";
import pathologyApprovalReducer from "./reducers/PathologyApprovalReducer";
import hospitalReducerApproval from "./reducers/HospitalReducerApproval";
import doctorReducerView from "./reducers/DoctorReducerView";
import hospitalReducerView from "./reducers/HospitalReducerView";
import pathologyReducerView from "./reducers/PathologyReducerView";
import pharmacyReducerView from "./reducers/PharmacyReducerView";
import searchReducer from "./reducers/SearchReducer";
import myPermissionsReducer from "./reducers/MyPermissionsReducer";
import departmentReducer from "./reducers/DepartmentReducer";
import teamReducer from "./reducers/TeamReducer";
import defaultTeamReducer from "./reducers/DefaultTeamReducer";
import mapReducer from "./reducers/MapReducer";
import agentBrokerReducerView from "./reducers/AgentBrokerReducerView";
import corporateReducerView from "./reducers/CorporateReducerView";
import globalLoaderReducer from "./reducers/GlobalLoaderReducer";
import salutationReducer from "./reducers/SalutationReducer";
import dashboardReducer from "./reducers/DashboardReducer";
import templateReducer from "./reducers/TemplateReducer";
import placeholderReducer from "./reducers/PlaceholderReducer";
import groupReducer from "./reducers/GroupReducer";
import headerReducer from "./reducers/HeaderReducer";
import reportReducer from "./reducers/ReportReducer";
import oldExcelReducer from "./reducers/OldExcelReducer";
import requestReducer from "./reducers/RequestReducer";

const Store = configureStore({
    reducer: {
        AuthReducer,
        requestReducer,
        userReducer,
        layoutReducer,
        stateReducer,
        cityReducer,
        talukaReducer,
        villageReducer,
        zoneReducer,
        masterReducer,
        geofenceReducer,
        userTypeReducer,
        generalSettingReducer,
        hospitalReducer,
        hospitalReducerView,
        doctorReducer,
        doctorReducerView,
        employeeReducer,
        pathologyReducer,
        pathologyReducerView,
        pharmacyReducerView,
        radiologyReducer,
        pharmacyReducer,
        agentBrokerReducer,
        agentBrokerReducerView,
        corporateReducer,
        corporateReducerView,
        basicSaveReducer,
        patientDataReducer,
        policyDataReducer,
        designationReducer,
        educationReducer,
        educationTypeReducer,
        gradeOfEvidenceReducer,
        reasonForRejectionReducer,
        sourceOfEvidenceReducer,
        fraudTypeReducer,
        policySubReasonReducer,
        incomeReducer,
        jobReducer,
        localityReducer,
        occupationReducer,
        relationshipReducer,
        departmentReducer,
        teamReducer,
        defaultTeamReducer,
        checklistReducer,
        subChecklistReducer,
        typeOfClaimReducer,
        userTypePermissionReducer,
        userPermissionReducer,
        insuranceReducer,
        insuranceManagerReducer,
        roomTypeReducer,
        hospitalizationReducer,
        injuryTypeReducer,
        caseDetailsReducer,
        healthReducer,
        tdsReducer,
        caseDoctorReducer,
        casePharmacyReducer,
        caseHospitalReducer,
        casePathologyReducer,
        occupationDataReducer,
        facilityReducer,
        keywordReducer,
        serviceTypeReducer,
        subClaimTypeReducer,
        claimTypeReducer,
        pincodeReducer,
        groupDetailReducer,
        recruitmentReducer,
        newEmployeeReducer,
        payrollReducer,
        accidentalCaseReducer,
        doctorReducerApproval,
        corporateApprovalReducer,
        pharmacyReducerApproval,
        pathologyApprovalReducer,
        hospitalReducerApproval,
        searchReducer,
        myPermissionsReducer,
        mapReducer,
        globalLoaderReducer,
        salutationReducer,
        dashboardReducer,
        templateReducer,
        placeholderReducer,
        groupReducer,
        headerReducer,
        reportReducer,
        oldExcelReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})

export default Store
